import React from 'react';
import featTextToImage from '../assets/feature_text_to_image.png';
import featEnhancePhoto from '../assets/feature_enhance_photo.png';
import featHairPreview from '../assets/feature_hair_preview.png';

export function TextToImagePhone() {
  return (
    <div className="relative max-w-[260px] mx-auto mt-6 transition-transform duration-500 group-hover:scale-105">
      <img src={featTextToImage} alt="Text to Image Generation" className="w-full h-auto drop-shadow-2xl rounded-2xl" />
    </div>
  );
}

export function EnhancePhone() {
  return (
    <div className="relative max-w-[260px] mx-auto mt-6 transition-transform duration-500 group-hover:scale-105">
      <img src={featEnhancePhoto} alt="Enhance Photos" className="w-full h-auto drop-shadow-2xl rounded-2xl" />
    </div>
  );
}

export function HairPhone() {
  return (
    <div className="relative max-w-[260px] mx-auto mt-6 transition-transform duration-500 group-hover:scale-105">
      <img src={featHairPreview} alt="Try Hairstyles" className="w-full h-auto drop-shadow-2xl rounded-2xl" />
    </div>
  );
}
